import { render, staticRenderFns } from "./SurfacePostMoreActions.vue?vue&type=template&id=617057b6&scoped=true&"
import script from "./SurfacePostMoreActions.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostMoreActions.vue?vue&type=script&lang=ts&"
import style0 from "./SurfacePostMoreActions.vue?vue&type=style&index=0&id=617057b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617057b6",
  null
  
)

export default component.exports